(() => {
  const installCroEnhancements = (root) => {
    if (!root) return;

    if (!document.getElementById('pb-klp-cro-enhancements')) {
      const style = document.createElement('style');
      style.id = 'pb-klp-cro-enhancements';
      style.textContent = `
        #choose-your-keepsake-style { scroll-margin-top: 7rem; }
        .pb-klp__hero-photo,
        .pb-klp__product-media,
        .pb-klp__product-card {
          touch-action: manipulation;
          -webkit-tap-highlight-color: rgba(40, 35, 31, 0.08);
        }
        .pb-klp__hero-photo-label {
          display: inline-flex;
          align-items: center;
          gap: 0.45rem;
          white-space: nowrap;
        }
        .pb-klp__media-cue {
          position: absolute;
          right: 1.2rem;
          bottom: 1.2rem;
          z-index: 3;
          display: inline-flex;
          align-items: center;
          gap: 0.45rem;
          padding: 0.7rem 1rem;
          background: rgba(255, 253, 249, 0.94);
          color: var(--pb-klp-ink);
          border: 1px solid rgba(40, 35, 31, 0.14);
          border-radius: 999px;
          box-shadow: 0 0.6rem 1.8rem rgba(40, 35, 31, 0.12);
          font-size: 1.08rem;
          font-weight: 700;
          letter-spacing: 0.02em;
          line-height: 1.2;
          pointer-events: none;
        }
        .pb-klp__product-card:focus-within {
          border-color: rgba(40, 35, 31, 0.42);
          box-shadow: 0 2rem 5.5rem rgba(46, 38, 31, 0.13);
        }
        .pb-klp__hero-photo:focus-visible,
        .pb-klp__product-media:focus-visible,
        .pb-klp__product-body h3 a:focus-visible,
        .pb-klp__product-card .button:focus-visible {
          outline: 0.2rem solid var(--pb-klp-ink);
          outline-offset: 0.25rem;
        }
        @media (hover: hover) {
          .pb-klp__hero-photo {
            transition: box-shadow 180ms ease, filter 180ms ease;
          }
          .pb-klp__hero-photo:hover {
            box-shadow: 0 3rem 7.5rem rgba(52, 42, 34, 0.23);
            filter: brightness(0.985);
          }
          .pb-klp__product-card {
            transition: border-color 180ms ease, box-shadow 180ms ease;
          }
          .pb-klp__product-card:hover {
            border-color: rgba(40, 35, 31, 0.3);
            box-shadow: 0 2rem 5.5rem rgba(46, 38, 31, 0.12);
          }
        }
        @media screen and (max-width: 749px) {
          #choose-your-keepsake-style { scroll-margin-top: 5.5rem; }
          .pb-klp__hero-photo-label {
            right: 0.8rem;
            bottom: 0.8rem;
            padding: 0.62rem 0.82rem;
            font-size: 0.98rem;
            letter-spacing: 0.045em;
          }
          .pb-klp__media-cue {
            right: 0.9rem;
            bottom: 0.9rem;
            padding: 0.68rem 0.9rem;
            font-size: 1.02rem;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .pb-klp__hero-photo,
          .pb-klp__product-card {
            transition: none !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    root.querySelectorAll('.pb-klp__hero-photo-label').forEach((label) => {
      const link = label.closest('.pb-klp__hero-photo');
      if (!link || label.dataset.pbKlpCueReady === 'true') return;
      label.dataset.pbKlpCueReady = 'true';
      label.textContent = link.classList.contains('pb-klp__hero-photo--book')
        ? 'Customize Book Style →'
        : 'Explore Classic →';
    });

    root.querySelectorAll('.pb-klp__product-media').forEach((media) => {
      if (media.querySelector('.pb-klp__media-cue')) return;
      const card = media.closest('.pb-klp__product-card');
      const heading = card?.querySelector('h3')?.textContent?.toLowerCase() || '';
      const cue = document.createElement('span');
      cue.className = 'pb-klp__media-cue';
      cue.setAttribute('aria-hidden', 'true');
      cue.textContent = heading.includes('book-style') ? 'View & customize →' : 'View designs →';
      media.appendChild(cue);
    });

    root.querySelectorAll('.pb-klp__product-card').forEach((card) => {
      if (card.dataset.pbKlpCardReady === 'true') return;
      const destination = card.querySelector('.pb-klp__product-body h3 a');
      if (!destination) return;
      card.dataset.pbKlpCardReady = 'true';

      card.addEventListener('click', (event) => {
        if (event.defaultPrevented) return;
        if (event.target.closest('a, button, input, select, textarea, summary, details')) return;
        const selection = window.getSelection?.().toString();
        if (selection) return;
        window.location.assign(destination.href);
      });
    });
  };

  const init = () => {
    const root = document.querySelector('[data-pb-klp]');
    const bottom = document.querySelector('[data-pb-klp-bottom]');
    if (!root) return;

    installCroEnhancements(root);

    if (!bottom || root.dataset.pbKlpReady === 'true') return;
    root.dataset.pbKlpReady = 'true';

    const faq = bottom.querySelector('[data-pb-klp-faq]');
    if (faq) {
      faq.querySelectorAll('details').forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          faq.querySelectorAll('details[open]').forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    }

    const sticky = bottom.querySelector('[data-pb-klp-sticky]');
    const hero = root.querySelector('[data-pb-klp-hero]');
    const chooser = root.querySelector('[data-pb-klp-chooser]');
    const finalCta = bottom.querySelector('[data-pb-klp-final]');
    if (!sticky || !hero || !chooser || !finalCta || !('IntersectionObserver' in window)) return;

    const visibility = { hero: true, chooser: false, final: false };
    const updateSticky = () => {
      const shouldShow = !visibility.hero && !visibility.chooser && !visibility.final;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === hero) visibility.hero = entry.isIntersecting;
        if (entry.target === chooser) visibility.chooser = entry.isIntersecting;
        if (entry.target === finalCta) visibility.final = entry.isIntersecting;
      });
      updateSticky();
    }, { threshold: 0.08 });

    observer.observe(hero);
    observer.observe(chooser);
    observer.observe(finalCta);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', init);
})();
